import { render, staticRenderFns } from "./domestic-organization.vue?vue&type=template&id=23f88daa&scoped=true&"
import script from "./domestic-organization.vue?vue&type=script&lang=js&"
export * from "./domestic-organization.vue?vue&type=script&lang=js&"
import style0 from "./domestic-organization.vue?vue&type=style&index=0&id=23f88daa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f88daa",
  null
  
)

export default component.exports